/**
 * anyway-atc-global.js
 * Intercepts ALL "Add to Cart" form submissions site-wide.
 * Converts them to AJAX, then opens the cart drawer.
 * Runs in capture phase so it fires before the theme's own handlers.
 */
(function () {
  'use strict';

  /* ── Helpers ── */
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.awOrig = btn.textContent.trim();
      btn.textContent    = 'Adding…';
      btn.disabled       = true;
    } else {
      btn.textContent = btn.dataset.awOrig || 'Add to Cart';
      btn.disabled    = false;
      delete btn.dataset.awOrig;
    }
  }

  /* ── Core AJAX add-to-cart ── */
  function ajaxAddToCart(body, btn) {
    fetch('/cart/add.js', {
      method:      'POST',
      credentials: 'include',
      headers: {
        'Content-Type':     'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      /* Shopify returns {status, description} on error */
      if (data.status && data.status >= 400) {
        alert(data.description || 'Could not add item. Please try again.');
        return;
      }

      /* Open / refresh the custom cart drawer */
      var drawer = getCartDrawer();
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else if (window.__awCartRefresh) {
        /* Fallback to our custom refresh helper */
        window.__awCartRefresh(data);
      } else {
        /* Last resort: reload */
        window.location.reload();
      }
    })
    .catch(function (err) {
      console.error('[AW-ATC] Add to cart failed:', err);
    })
    .finally(function () {
      setButtonLoading(btn, false);
    });
  }

  /* ── Form submit interceptor ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    /* Only intercept add-to-cart forms */
    if (!form || !form.getAttribute) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;

    /* Skip if the pressed button is "buy_it_now" or has data-no-ajax */
    var activeEl = document.activeElement;
    if (activeEl && activeEl.dataset && activeEl.dataset.noAjax) return;
    if (activeEl && activeEl.name === 'buy-now') return;

    e.preventDefault();
    e.stopPropagation();

    /* Find the submit button for loading state */
    var btn = null;
    if (activeEl && activeEl.form === form && activeEl.type === 'submit') {
      btn = activeEl;
    } else {
      btn = form.querySelector('[type="submit"]:not([name="buy_it_now"])');
    }
    setButtonLoading(btn, true);

    /* Extract fields from FormData */
    var fd = new FormData(form);
    var id  = fd.get('id');
    if (!id) {
      setButtonLoading(btn, false);
      return;
    }

    var body = {
      id:           parseInt(id, 10),
      quantity:     parseInt(fd.get('quantity') || '1', 10),
      sections:     ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    /* Selling plan (subscription products) */
    var sp = fd.get('selling_plan');
    if (sp) body.selling_plan = parseInt(sp, 10);

    /* Line item properties */
    var props = {};
    fd.forEach(function (val, key) {
      if (key.indexOf('properties[') === 0 && key.slice(-1) === ']') {
        var propKey = key.slice(11, -1);
        props[propKey] = val;
      }
    });
    if (Object.keys(props).length > 0) body.properties = props;

    ajaxAddToCart(body, btn);
  }, true /* capture phase */);

  /* ── Cart icon click opens drawer ── */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('#cart-icon-bubble, [href="/cart"], [data-open-cart-drawer]');
    if (!el) return;
    var drawer = getCartDrawer();
    if (!drawer) return;
    e.preventDefault();
    drawer.open(el);
  });

})();
